import { render, staticRenderFns } from "./application-quick-actions.vue?vue&type=template&id=641060ac"
import script from "./application-quick-actions.vue?vue&type=script&lang=ts"
export * from "./application-quick-actions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641060ac')) {
      api.createRecord('641060ac', component.options)
    } else {
      api.reload('641060ac', component.options)
    }
    module.hot.accept("./application-quick-actions.vue?vue&type=template&id=641060ac", function () {
      api.rerender('641060ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application/components/application-quick-actions.vue"
export default component.exports